// extracted by mini-css-extract-plugin
export default {"blender_bottle_item":"cz","blender_bottle_img":"ez","blender_bottle_info":"fz","blender_bottle_title":"gz","blender_bottle_bold":"hz","blender_bottle_usual":"iz","blender_bottle_item_mob":"jz","addbutton":"kz","blender_bottle_title_mob":"lz","blender_bottle_bold_mob":"mz","blender_bottle_usual_mob":"nz","bolder":"oz","bottom_margin_4":"pz","bottom_margin_16":"qz"};
    if(module.hot) {
      // 1713969933212
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  